export function Table({ children }) {
  return (
    <div className={'table-wrapper'}>
      <table>{children}</table>
    </div>
  )
}
